module.exports = __webpack_public_path__ + "static/media/vue-9.60dfaadb.svg";